import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const BASE = 'https://books.studydost.ai';
const enc = (s) => encodeURIComponent(s);

// ── Complete NCERT catalogue (verified against R2 bucket) ─────────────────────
// NOTE: Chemistry 12 English is NOT in bucket — only Hindi version available
// NOTE: Chemistry 11 English has 2 parts; Chemistry 12 has Hindi parts only
// NOTE: Philosophy filename has typo "Phylosophy" — kept as-is to match bucket
const BOOKS = [
  // ── Class 1-5 ────────────────────────────────────────────────────────────
  { id: 'eng1',   cls: 1,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 1.pdf' },
  { id: 'eng2',   cls: 2,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 2.pdf' },
  { id: 'eng3',   cls: 3,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 3.pdf' },
  { id: 'eng4',   cls: 4,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 4.pdf' },
  { id: 'eng5',   cls: 5,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 5.pdf' },
  { id: 'ss4h',   cls: 4,  subject: 'Social Science', lang: 'HI', title: 'सामाजिक विज्ञान',            file: 'Social Science 4 Hindi.pdf' },
  { id: 'ss5e',   cls: 5,  subject: 'Social Science', lang: 'EN', title: 'Social Science',             file: 'Social Science 5 English.pdf' },
  { id: 'ss5h',   cls: 5,  subject: 'Social Science', lang: 'HI', title: 'सामाजिक विज्ञान',            file: 'Social Science 5 Hindi.pdf' },

  // ── Class 6 ──────────────────────────────────────────────────────────────
  { id: 'eng6',   cls: 6,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 6.pdf' },
  { id: 'sci6e',  cls: 6,  subject: 'Science',        lang: 'EN', title: 'Science',                    file: 'Science 6 English.pdf' },
  { id: 'sci6h',  cls: 6,  subject: 'Science',        lang: 'HI', title: 'विज्ञान',                    file: 'Science 6 Hindi.pdf' },
  { id: 'ss6e',   cls: 6,  subject: 'Social Science', lang: 'EN', title: 'Social Science',             file: 'Social Science 6 English.pdf' },
  { id: 'ss6h',   cls: 6,  subject: 'Social Science', lang: 'HI', title: 'सामाजिक विज्ञान',            file: 'Social Science 6 Hindi.pdf' },

  // ── Class 7 ──────────────────────────────────────────────────────────────
  { id: 'eng7',   cls: 7,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 7.pdf' },
  { id: 'mat7p1', cls: 7,  subject: 'Maths',          lang: 'EN', title: 'Maths Part 1',               file: 'Maths 7 Part 1 English.pdf' },
  { id: 'mat7p2', cls: 7,  subject: 'Maths',          lang: 'EN', title: 'Maths Part 2',               file: 'Maths 7 Part 2 English.pdf' },
  { id: 'sci7e',  cls: 7,  subject: 'Science',        lang: 'EN', title: 'Science',                    file: 'Science 7 English.pdf' },
  { id: 'sci7h',  cls: 7,  subject: 'Science',        lang: 'HI', title: 'विज्ञान',                    file: 'Science 7 Hindi.pdf' },
  { id: 'ss7e1',  cls: 7,  subject: 'Social Science', lang: 'EN', title: 'Social Science Part 1',      file: 'Social Science 7 Part 1 English.pdf' },
  { id: 'ss7e2',  cls: 7,  subject: 'Social Science', lang: 'EN', title: 'Social Science Part 2',      file: 'Social Science 7 Part 2 English.pdf' },
  { id: 'ss7h',   cls: 7,  subject: 'Social Science', lang: 'HI', title: 'सामाजिक विज्ञान',            file: 'Social Science 7 Hindi.pdf' },

  // ── Class 8 ──────────────────────────────────────────────────────────────
  { id: 'eng8',   cls: 8,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 8.pdf' },
  { id: 'mat8p1', cls: 8,  subject: 'Maths',          lang: 'EN', title: 'Maths Part 1',               file: 'Maths 8 Part 1 English.pdf' },
  { id: 'mat8p2', cls: 8,  subject: 'Maths',          lang: 'EN', title: 'Maths Part 2',               file: 'Maths 8 Part 2 English.pdf' },
  { id: 'sci8e',  cls: 8,  subject: 'Science',        lang: 'EN', title: 'Science',                    file: 'Science 8 English.pdf' },
  { id: 'sci8h',  cls: 8,  subject: 'Science',        lang: 'HI', title: 'विज्ञान',                    file: 'Science 8 Hindi.pdf' },
  { id: 'ss8e',   cls: 8,  subject: 'Social Science', lang: 'EN', title: 'Social Science Part 1',      file: 'Social Science 8 Part 1 English.pdf' },
  { id: 'ss8h',   cls: 8,  subject: 'Social Science', lang: 'HI', title: 'सामाजिक विज्ञान',            file: 'Social Science 8 Hindi.pdf' },

  // ── Class 9 ──────────────────────────────────────────────────────────────
  { id: 'eng9',   cls: 9,  subject: 'English',        lang: 'EN', title: 'English',                    file: 'English Class 9.pdf' },
  { id: 'mat9',   cls: 9,  subject: 'Maths',          lang: 'EN', title: 'Maths',                      file: 'Maths 9 English.pdf' },
  { id: 'sci9e',  cls: 9,  subject: 'Science',        lang: 'EN', title: 'Science',                    file: 'Science 9 English.pdf' },

  // ── Class 10 ─────────────────────────────────────────────────────────────
  { id: 'eng10a', cls: 10, subject: 'English',        lang: 'EN', title: 'First Flight',               file: 'English Class 10 First Flight.pdf' },
  { id: 'eng10b', cls: 10, subject: 'English',        lang: 'EN', title: 'Footprints without Feet',    file: 'English Class 10 Footprints without Feet Supp. Reader.pdf' },
  { id: 'mat10',  cls: 10, subject: 'Maths',          lang: 'EN', title: 'Maths',                      file: 'Maths 10 English.pdf' },
  { id: 'sci10e', cls: 10, subject: 'Science',        lang: 'EN', title: 'Science',                    file: 'Science 10 English.pdf' },
  { id: 'sci10h', cls: 10, subject: 'Science',        lang: 'HI', title: 'विज्ञान',                    file: 'Science 10 Hindi.pdf' },
  { id: 'geo10',  cls: 10, subject: 'Geography',      lang: 'EN', title: 'Geography',                  file: 'Geography 10 English.pdf' },
  { id: 'his10',  cls: 10, subject: 'History',        lang: 'EN', title: 'History',                    file: 'History 10 English.pdf' },
  { id: 'pol10',  cls: 10, subject: 'Pol. Science',   lang: 'EN', title: 'Political Science',          file: 'Political Science 10 English.pdf' },
  { id: 'eco10',  cls: 10, subject: 'Economics',      lang: 'EN', title: 'Economics',                  file: 'Economics 10 English.pdf' },
  { id: 'ss10h1', cls: 10, subject: 'Social Science', lang: 'HI', title: 'आर्थिक विकास की समझ',       file: 'Social Science 10 Hindi Arthik Vikas ki Samajh.pdf' },
  { id: 'ss10h2', cls: 10, subject: 'Social Science', lang: 'HI', title: 'लोकतांत्रिक राजनीति',        file: 'Social Science 10 Hindi Loktantrik Rajniti.pdf' },
  { id: 'ss10h3', cls: 10, subject: 'Social Science', lang: 'HI', title: 'समकालीन भारत',              file: 'Social Science 10 Hindi Samkalin Bharat.pdf' },

  // ── Class 11 ─────────────────────────────────────────────────────────────
  { id: 'eng11a', cls: 11, subject: 'English',        lang: 'EN', title: 'Hornbill',                   file: 'English Class 11 Hornbill.pdf' },
  { id: 'eng11b', cls: 11, subject: 'English',        lang: 'EN', title: 'Snapshots',                  file: 'English Class 11 Snapshots Suppl. Reader.pdf' },
  { id: 'eng11c', cls: 11, subject: 'English',        lang: 'EN', title: 'Woven Words',                file: 'English Class 11 Woven Words.pdf' },
  { id: 'mat11',  cls: 11, subject: 'Maths',          lang: 'EN', title: 'Maths',                      file: 'Maths 11 English.pdf' },
  { id: 'phy11e1',cls: 11, subject: 'Physics',        lang: 'EN', title: 'Physics Part 1',             file: 'Physics Class 11 Part 1 English.pdf' },
  { id: 'phy11e2',cls: 11, subject: 'Physics',        lang: 'EN', title: 'Physics Part 2',             file: 'Physics Class 11 Part 2 English.pdf' },
  { id: 'phy11h1',cls: 11, subject: 'Physics',        lang: 'HI', title: 'भौतिकी भाग 1',               file: 'Physics 11 Part 1 Hindi.pdf' },
  { id: 'phy11h2',cls: 11, subject: 'Physics',        lang: 'HI', title: 'भौतिकी भाग 2',               file: 'Physics 11 Part 2 Hindi.pdf' },
  { id: 'che11e1',cls: 11, subject: 'Chemistry',      lang: 'EN', title: 'Chemistry Part 1',           file: 'Chemistry Class 11 Part 1 English.pdf' },
  { id: 'che11e2',cls: 11, subject: 'Chemistry',      lang: 'EN', title: 'Chemistry Part 2',           file: 'Chemistry Class 11 Part 2 English.pdf' },
  { id: 'che11h1',cls: 11, subject: 'Chemistry',      lang: 'HI', title: 'रसायन विज्ञान भाग 1',        file: 'Chemistry 11 Part 1 Hindi.pdf' },
  { id: 'che11h2',cls: 11, subject: 'Chemistry',      lang: 'HI', title: 'रसायन विज्ञान भाग 2',        file: 'Chemistry 11 Part 2 Hindi.pdf' },
  { id: 'bio11e', cls: 11, subject: 'Biology',        lang: 'EN', title: 'Biology',                    file: 'Biology Class 11 English.pdf' },
  { id: 'bio11h', cls: 11, subject: 'Biology',        lang: 'HI', title: 'जीव विज्ञान',                file: 'Biology 11 Hindi.pdf' },
  { id: 'his11',  cls: 11, subject: 'History',        lang: 'EN', title: 'History',                    file: 'History 11 English.pdf' },
  { id: 'geo11a', cls: 11, subject: 'Geography',      lang: 'EN', title: 'Geography Part 1',           file: 'Geography 11 Part 1 English.pdf' },
  { id: 'geo11b', cls: 11, subject: 'Geography',      lang: 'EN', title: 'Practical Work',             file: 'Geography 11 Part 2 English PRACTICAL WORK IN GEOGRAPHY.pdf' },
  { id: 'geo11c', cls: 11, subject: 'Geography',      lang: 'EN', title: 'Physical Environment',       file: 'Geography 11 Part 3 English PHYSICAL ENVIRONMENT.pdf' },
  { id: 'pol11a', cls: 11, subject: 'Pol. Science',   lang: 'EN', title: 'Indian Constitution',        file: 'Political Science 11 Part 1 English Indian Constitution.pdf' },
  { id: 'pol11b', cls: 11, subject: 'Pol. Science',   lang: 'EN', title: 'Political Theory',           file: 'Political Science 11 Part 2 English Political Theory.pdf' },
  { id: 'eco11a', cls: 11, subject: 'Economics',      lang: 'EN', title: 'Indian Economic Dev.',       file: 'Economics 11 Part 1 English INDIAN ECONOMIC DEVELOPMENT.pdf' },
  { id: 'eco11b', cls: 11, subject: 'Economics',      lang: 'EN', title: 'Statistics for Economics',   file: 'Economics 11 Part 2 English STATISTICS FOR ECONOMICS.pdf' },
  { id: 'acc11a', cls: 11, subject: 'Accountancy',    lang: 'EN', title: 'Accountancy Part 1',         file: 'Accountancy 11 Part 1 English.pdf' },
  { id: 'acc11b', cls: 11, subject: 'Accountancy',    lang: 'EN', title: 'Accountancy Part 2',         file: 'Accountancy 11 Part 2 English.pdf' },
  { id: 'bs11',   cls: 11, subject: 'Business',       lang: 'EN', title: 'Business Studies',           file: 'Business Studies 11 English.pdf' },
  { id: 'cs11',   cls: 11, subject: 'Comp. Science',  lang: 'EN', title: 'Computer Science',           file: 'Computer Science 11 English.pdf' },
  { id: 'ip11',   cls: 11, subject: 'Informatics',    lang: 'EN', title: 'Informatics Practices',      file: 'Informatics Practices 11 English.pdf' },
  { id: 'soc11a', cls: 11, subject: 'Sociology',      lang: 'EN', title: 'Sociology Part 1',           file: 'Sociology 11 Part 1 English.pdf' },
  { id: 'soc11b', cls: 11, subject: 'Sociology',      lang: 'EN', title: 'Understanding Society',      file: 'Sociology 11 Part 2 English UNDERSTANDING SOCIETY.pdf' },
  { id: 'psy11',  cls: 11, subject: 'Psychology',     lang: 'EN', title: 'Psychology',                 file: 'Psychology 11 English.pdf' },
  { id: 'bio11t', cls: 11, subject: 'Biotechnology',  lang: 'EN', title: 'Biotechnology',              file: 'Biotechnology 11 English.pdf' },
  { id: 'phi11',  cls: 11, subject: 'Philosophy',     lang: 'EN', title: 'Knowledge Traditions',       file: 'Phylosophy 11 English Knowledge Traditions and Practices of India.pdf' },

  // ── Class 12 ─────────────────────────────────────────────────────────────
  { id: 'eng12a', cls: 12, subject: 'English',        lang: 'EN', title: 'Flamingo',                   file: 'English Class 12 Flamingo.pdf' },
  { id: 'eng12b', cls: 12, subject: 'English',        lang: 'EN', title: 'Vistas',                     file: 'English Class 12 Vistas.pdf' },
  { id: 'eng12c', cls: 12, subject: 'English',        lang: 'EN', title: 'Kaleidoscope',               file: 'English Class 12 Kaliedoscope.pdf' },
  { id: 'mat12a', cls: 12, subject: 'Maths',          lang: 'EN', title: 'Maths Part 1',               file: 'Maths 12 Part 1 English.pdf' },
  { id: 'mat12b', cls: 12, subject: 'Maths',          lang: 'EN', title: 'Maths Part 2',               file: 'Maths 12 Part 2 English.pdf' },
  { id: 'phy12e1',cls: 12, subject: 'Physics',        lang: 'EN', title: 'Physics Part 1',             file: 'Physics Class 12 Part 1 English.pdf' },
  { id: 'phy12e2',cls: 12, subject: 'Physics',        lang: 'EN', title: 'Physics Part 2',             file: 'Physics Class 12 Part 2 English.pdf' },
  { id: 'phy12h1',cls: 12, subject: 'Physics',        lang: 'HI', title: 'भौतिकी भाग 1',               file: 'Physics 12 Part 1 Hindi.pdf' },
  { id: 'phy12h2',cls: 12, subject: 'Physics',        lang: 'HI', title: 'भौतिकी भाग 2',               file: 'Physics 12 Part 2 Hindi.pdf' },
  { id: 'che12e1',cls: 12, subject: 'Chemistry',      lang: 'EN', title: 'Chemistry Part 1',           file: 'Chemistry Class 12 Part 1 English.pdf' },
  { id: 'che12e2',cls: 12, subject: 'Chemistry',      lang: 'EN', title: 'Chemistry Part 2',           file: 'Chemistry Class 12 Part 2 English.pdf' },
  { id: 'che12h1',cls: 12, subject: 'Chemistry',      lang: 'HI', title: 'रसायन विज्ञान भाग 1',        file: 'Chemistry 12 Part 1 Hindi.pdf' },
  { id: 'che12h2',cls: 12, subject: 'Chemistry',      lang: 'HI', title: 'रसायन विज्ञान भाग 2',        file: 'Chemistry 12 Part 2 Hindi.pdf' },
  { id: 'bio12e', cls: 12, subject: 'Biology',        lang: 'EN', title: 'Biology',                    file: 'Biology Class 12 English.pdf' },
  { id: 'bio12h', cls: 12, subject: 'Biology',        lang: 'HI', title: 'जीव विज्ञान',                file: 'Biology 12 Hindi.pdf' },
  { id: 'his12a', cls: 12, subject: 'History',        lang: 'EN', title: 'History Part 1',             file: 'History 12 Part 1 English.pdf' },
  { id: 'his12b', cls: 12, subject: 'History',        lang: 'EN', title: 'History Part 2',             file: 'History 12 Part 2 English.pdf' },
  { id: 'his12c', cls: 12, subject: 'History',        lang: 'EN', title: 'History Part 3',             file: 'History 12 Part 3 English.pdf' },
  { id: 'geo12a', cls: 12, subject: 'Geography',      lang: 'EN', title: 'Fundamentals of Human',      file: 'Geography 12 Part 1 English Fundamentals of Human.pdf' },
  { id: 'geo12b', cls: 12, subject: 'Geography',      lang: 'EN', title: 'Practical Work',             file: 'Geography 12 Part 2 English Practical Work in Geography.pdf' },
  { id: 'geo12c', cls: 12, subject: 'Geography',      lang: 'EN', title: 'India: People & Economy',    file: 'Geography 12 Part 3 English India -People And Economy.pdf' },
  { id: 'pol12a', cls: 12, subject: 'Pol. Science',   lang: 'EN', title: 'Contemporary World Politics', file: 'Political Science 12 Part 1 Contemporary World Politics.pdf' },
  { id: 'pol12b', cls: 12, subject: 'Pol. Science',   lang: 'EN', title: 'Politics in India',          file: 'Political Science 12 Part 2 Politics in India Since Independence.pdf' },
  { id: 'eco12a', cls: 12, subject: 'Economics',      lang: 'EN', title: 'Introductory Microeconomics', file: 'Economics 12 Part 1 English Introductory Microeconomics.pdf' },
  { id: 'eco12b', cls: 12, subject: 'Economics',      lang: 'EN', title: 'Introductory Macroeconomics', file: 'Economics 12 Part 2 English Introductory Macroeconomics.pdf' },
  { id: 'acc12a', cls: 12, subject: 'Accountancy',    lang: 'EN', title: 'Accountancy Part 1',         file: 'Accountancy 12 Part 1 English.pdf' },
  { id: 'acc12b', cls: 12, subject: 'Accountancy',    lang: 'EN', title: 'Accountancy Part 2',         file: 'Accountancy 12 Part 2 English.pdf' },
  { id: 'bs12a',  cls: 12, subject: 'Business',       lang: 'EN', title: 'Business Studies Part 1',    file: 'Business Studies 12 Part 1 English.pdf' },
  { id: 'bs12b',  cls: 12, subject: 'Business',       lang: 'EN', title: 'Business Studies Part 2',    file: 'Business Studies 12 Part 2 English.pdf' },
  { id: 'cs12',   cls: 12, subject: 'Comp. Science',  lang: 'EN', title: 'Computer Science',           file: 'Computer Science 12 English.pdf' },
  { id: 'ip12',   cls: 12, subject: 'Informatics',    lang: 'EN', title: 'Informatics Practices',      file: 'Informatics Practices 12 English.pdf' },
  { id: 'soc12a', cls: 12, subject: 'Sociology',      lang: 'EN', title: 'Indian Society',             file: 'Sociology 12 Part 1 English Indian Society.pdf' },
  { id: 'soc12b', cls: 12, subject: 'Sociology',      lang: 'EN', title: 'Social Change & Development', file: 'Sociology 12 Part 2 Social Change and Development in India.pdf' },
  { id: 'psy12',  cls: 12, subject: 'Psychology',     lang: 'EN', title: 'Psychology',                 file: 'Psychology 12 English.pdf' },
  { id: 'bio12t', cls: 12, subject: 'Biotechnology',  lang: 'EN', title: 'Biotechnology',              file: 'Biotechnology 12 English.pdf' },
];

const CLASSES = [1,2,3,4,5,6,7,8,9,10,11,12];
const SUBJECTS = ['All', ...new Set(BOOKS.map(b => b.subject))];

export default function BooksPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [selectedClass, setSelectedClass] = useState('All');
  const [selectedSubject, setSelectedSubject] = useState('All');
  const [search, setSearch] = useState('');
  const [langFilter, setLangFilter] = useState('All');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingBookUrl, setPendingBookUrl] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('studydost_token');
    if (token) {
      authAPI.getProfile(token)
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('studydost_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const sendOTP = async () => {
    if (!phone || phone.length < 10) return alert('Valid phone number required');
    setAuthLoading(true);
    try {
      await authAPI.sendOTP(phone);
      setOtpSent(true);
    } catch (e) {
      alert('Failed to send OTP. Try again.');
    } finally {
      setAuthLoading(false);
    }
  };

  const verifyOTP = async () => {
    if (!otp || otp.length < 4) return alert('Enter OTP');
    setAuthLoading(true);
    try {
      const res = await authAPI.verifyOTP(phone, otp);
      localStorage.setItem('studydost_token', res.data.token);
      setUser(res.data.user);
    } catch (e) {
      alert('Invalid OTP. Try again.');
    } finally {
      setAuthLoading(false);
    }
  };

  const filteredBooks = BOOKS.filter(b => {
    if (selectedClass !== 'All' && b.cls !== parseInt(selectedClass)) return false;
    if (selectedSubject !== 'All' && b.subject !== selectedSubject) return false;
    if (langFilter !== 'All' && b.lang !== langFilter) return false;
    if (search && !b.title.toLowerCase().includes(search.toLowerCase()) &&
        !b.subject.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const handleBookClick = (e, url) => {
    if (!user) {
      e.preventDefault();
      setPendingBookUrl(url);
      setShowAuthModal(true);
    }
    // else: let the <a> tag open normally
  };

  // After login, open the book they clicked
  useEffect(() => {
    if (user && pendingBookUrl) {
      window.open(pendingBookUrl, '_blank');
      setPendingBookUrl(null);
      setShowAuthModal(false);
    }
  }, [user, pendingBookUrl]);

  if (loading) return (
    <div style={styles.center}>
      <div style={styles.spinner} />
    </div>
  );

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.back} onClick={() => navigate('/')}>← Back</button>
        <h1 style={styles.headerTitle}>📚 NCERT Books</h1>
        <span style={styles.count}>{filteredBooks.length} books</span>
      </div>

      {/* Filters */}
      <div style={styles.filters}>
        <input
          style={styles.search}
          placeholder="Search subject or title…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div style={styles.filterRow}>
          <select style={styles.select} value={selectedClass} onChange={e => setSelectedClass(e.target.value)}>
            <option value="All">All Classes</option>
            {CLASSES.map(c => <option key={c} value={c}>Class {c}</option>)}
          </select>
          <select style={styles.select} value={selectedSubject} onChange={e => setSelectedSubject(e.target.value)}>
            {SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <select style={styles.select} value={langFilter} onChange={e => setLangFilter(e.target.value)}>
            <option value="All">EN + HI</option>
            <option value="EN">English</option>
            <option value="HI">Hindi</option>
          </select>
        </div>
      </div>

      {/* Book Grid */}
      <div style={styles.grid}>
        {filteredBooks.map(book => (
          <a
            key={book.id}
            href={`${BASE}/${enc(book.file)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.card}
            onClick={e => handleBookClick(e, `${BASE}/${enc(book.file)}`)}
          >
            <div style={styles.cardEmoji}>
              {book.subject.includes('Math') ? '🔢' :
               book.subject.includes('Science') || book.subject.includes('Bio') || book.subject.includes('Chem') || book.subject.includes('Phys') ? '🔬' :
               book.subject.includes('History') ? '🏛️' :
               book.subject.includes('Geography') ? '🌍' :
               book.subject.includes('English') ? '📖' :
               book.subject.includes('Hindi') ? '📝' :
               book.subject.includes('Pol') ? '⚖️' :
               book.subject.includes('Economics') || book.subject.includes('Account') || book.subject.includes('Business') ? '💹' :
               '📗'}
            </div>
            <div style={styles.cardBody}>
              <div style={styles.cardClass}>Class {book.cls}</div>
              <div style={styles.cardSubject}>{book.subject}</div>
              <div style={styles.cardTitle}>{book.title}</div>
              <div style={styles.cardLang}>{book.lang === 'HI' ? '🇮🇳 Hindi' : '🇬🇧 English'}</div>
            </div>
            <div style={styles.cardArrow}>↗</div>
          </a>
        ))}
        {filteredBooks.length === 0 && (
          <div style={styles.empty}>No books found for selected filters</div>
        )}
      </div>

      {/* Auth Modal — shown only on book click if not logged in */}
      {showAuthModal && (
        <div style={styles.modalOverlay} onClick={() => setShowAuthModal(false)}>
          <div style={styles.authCard} onClick={e => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={() => setShowAuthModal(false)}>✕</button>
            <div style={styles.logo}>📚</div>
            <h2 style={styles.authTitle}>Login to Download</h2>
            <p style={styles.authSub}>Free login required to open books</p>
            {!otpSent ? (
              <>
                <input
                  style={styles.input}
                  type="tel"
                  placeholder="Mobile number"
                  value={phone}
                  onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0,10))}
                />
                <button style={styles.btn} onClick={sendOTP} disabled={authLoading}>
                  {authLoading ? 'Sending…' : 'Send OTP'}
                </button>
              </>
            ) : (
              <>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={e => setOtp(e.target.value.replace(/\D/g,'').slice(0,6))}
                />
                <button style={styles.btn} onClick={verifyOTP} disabled={authLoading}>
                  {authLoading ? 'Verifying…' : 'Verify & Login'}
                </button>
                <p style={styles.resend} onClick={() => { setOtpSent(false); setOtp(''); }}>
                  ← Change number
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page:        { minHeight: '100vh', background: '#f8fafc', fontFamily: 'sans-serif' },
  center:      { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' },
  spinner:     { width: 40, height: 40, border: '4px solid #e2e8f0', borderTop: '4px solid #6366f1', borderRadius: '50%', animation: 'spin 1s linear infinite' },
  authWrap:    { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f8fafc', padding: 16 },
  authCard:    { background: '#fff', borderRadius: 16, padding: 32, maxWidth: 360, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', position: 'relative' },
  logo:        { fontSize: 48, marginBottom: 8 },
  authTitle:   { fontSize: 22, fontWeight: 700, color: '#1e293b', margin: '0 0 4px' },
  authSub:     { color: '#64748b', fontSize: 14, marginBottom: 24 },
  input:       { width: '100%', padding: '12px 16px', border: '2px solid #e2e8f0', borderRadius: 10, fontSize: 16, marginBottom: 12, boxSizing: 'border-box', outline: 'none' },
  btn:         { width: '100%', padding: '13px 0', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer' },
  resend:      { marginTop: 12, color: '#6366f1', cursor: 'pointer', fontSize: 14 },
  header:      { background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 },
  back:        { background: 'none', border: 'none', color: '#6366f1', fontSize: 14, cursor: 'pointer', fontWeight: 600 },
  headerTitle: { flex: 1, fontSize: 18, fontWeight: 700, color: '#1e293b', margin: 0 },
  count:       { fontSize: 13, color: '#94a3b8', background: '#f1f5f9', padding: '3px 10px', borderRadius: 20 },
  filters:     { padding: '12px 16px', background: '#fff', borderBottom: '1px solid #e2e8f0' },
  search:      { width: '100%', padding: '10px 14px', border: '2px solid #e2e8f0', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', marginBottom: 8, outline: 'none' },
  filterRow:   { display: 'flex', gap: 8 },
  select:      { flex: 1, padding: '8px 10px', border: '2px solid #e2e8f0', borderRadius: 8, fontSize: 13, background: '#fff', outline: 'none' },
  grid:        { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, padding: 16 },
  card:        { background: '#fff', borderRadius: 12, padding: 14, display: 'flex', flexDirection: 'column', textDecoration: 'none', border: '1px solid #e2e8f0', transition: 'box-shadow 0.2s', cursor: 'pointer', position: 'relative' },
  cardEmoji:   { fontSize: 28, marginBottom: 8 },
  cardBody:    { flex: 1 },
  cardClass:   { fontSize: 11, fontWeight: 700, color: '#6366f1', textTransform: 'uppercase', letterSpacing: 0.5 },
  cardSubject: { fontSize: 13, fontWeight: 700, color: '#1e293b', marginTop: 2 },
  cardTitle:   { fontSize: 12, color: '#475569', marginTop: 2 },
  cardLang:    { fontSize: 11, color: '#94a3b8', marginTop: 6 },
  cardArrow:   { position: 'absolute', top: 10, right: 12, color: '#94a3b8', fontSize: 14 },
  empty:       { gridColumn: '1/-1', textAlign: 'center', color: '#94a3b8', padding: 40 },
  modalOverlay:{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100, padding: 16 },
  closeBtn:    { position: 'absolute', top: 12, right: 14, background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#94a3b8' },
};
